export const tempImg =
  'https://dummyimage.com/1080x920/ffffff/000000.jpg&text=Fogo+Cruzado';
